import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import { BestSellingHandoutData } from "modules/Discover/components";
import { useAuth } from "context/authContext";
import { Content as ContentType } from "types/types";
import { ContentsService } from "services/ContentsService";

type Props = {};

const BestSellingHandoutContainer = (props: Props) => {
  const { searchTerm } = useAuth();

  const [allHandoutsData, setAllHandoutsData] = useState<ContentType[]>([]);
  const [allFilteredHandouts, setAllFilteredHandouts] = useState<ContentType[]>([]);

  const getContentData = async () => {
    try {
      // Fetch all contents
      const contents = await ContentsService.getContents();

      // Resolve `createdBy` field (DocumentReference) to user data
      const contentWithUserData = await Promise.all(
        contents.map(async (content: ContentType) => {
          const createdBy = content.createdBy;

          if (!createdBy) {
            console.warn("Invalid createdBy field:", createdBy);
            return { ...content, userData: null };
          }

          try {
            const userData = await ContentsService.getUserByCreatedBy(
              createdBy
            );
            return {
              ...content,
              userData: userData || null, // Include user data or null if not found
            };
          } catch (error) {
            console.error(
              "Error fetching user data for createdBy:",
              createdBy,
              error
            );
            return { ...content, userData: null };
          }
        })
      );

      // ✅ Only keep published content
      const publishedContent = contentWithUserData.filter(
        (content) => content.isPublished
      );

      setAllHandoutsData(publishedContent); // Set initial filtered contents

      // setAllHandoutsData(contentWithUserData);
    } catch (error) {
      console.error("Failed to fetch handout data:", error);
    }
  };

  useEffect(() => {
    getContentData();
  }, []);

  // Filter content based on search term
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setAllFilteredHandouts(allHandoutsData); // Reset to full dataset if search is cleared
    } else {
      const filtered = allHandoutsData.filter((content) => {
        const titleMatch = content.title.toLowerCase().includes(searchTerm.toLowerCase());
        //@ts-ignore
        const firstNameMatch = content.userData?.firstName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        //@ts-ignore
        const lastNameMatch = content.userData?.lastName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());

        return titleMatch || firstNameMatch || lastNameMatch;
      });

      setAllFilteredHandouts(filtered);
    }

  }, [searchTerm, allHandoutsData]);

  return (
    <AppLayout>
      <BestSellingHandoutData
        allHandoutsData={allFilteredHandouts}
        setAllHandoutsData={setAllFilteredHandouts}
      />
    </AppLayout>
  );
};

export default BestSellingHandoutContainer;
